import { useContext } from "react";
import JobTable from "../../../components/JobTable";
import { JobContext } from "../../../context/JobContext";

const JobListPage = () => {
  const { states, actions } = useContext(JobContext);

  const {
    filteredJobs,
    loading,
    error,
    cities,
    companies,
    jobTypes,
    statuses,
  } = states;

  const {
    handleDelete,
    setSearch,
    setCity,
    setCompany,
    setFilterType,
    setFilterStatus,
  } = actions;

  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-semibold mb-8">List Lowongan Pekerjaan</h1>

      <div className="mb-6 bg-white p-4 rounded-xl shadow-sm">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          <input
            type="text"
            placeholder="Cari Judul Pekerjaan..."
            onChange={(e) => setSearch(e.target.value)}
            className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
          />

          <select
            onChange={(e) => setCity(e.target.value)}
            className="px-4 py-2 border rounded-lg">
            <option value="">Semua Kota</option>
            {cities.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>

          <select
            onChange={(e) => setCompany(e.target.value)}
            className="px-4 py-2 border rounded-lg">
            <option value="">Semua Perusahaan</option>
            {companies.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>

          <select
            onChange={(e) => setFilterType(e.target.value)}
            className="px-4 py-2 border rounded-lg">
            <option value="">Semua Tipe</option>
            {jobTypes.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>

          <select
            onChange={(e) => setFilterStatus(e.target.value)}
            className="px-4 py-2 border rounded-lg">
            <option value="">Semua Status</option>
            {statuses.map((s) => (
              <option key={s.value} value={s.value}>
                {s.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <JobTable
        loading={loading}
        error={error}
        jobs={filteredJobs}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default JobListPage;
